<template>
  <main class="container w-full max-w-lg my-12 py-12 px-6 border rounded-lg">
    <h1 class="text-2xl font-semibold text-center mb-6">Log In to Your Account</h1>
    <LoginSocial class="w-full" @on-success="onLoginSuccess" />
    <Separator label="Or" class="my-6" />
    <LoginForm @submit="onSubmitLogin" />
  </main>
</template>

<script lang="ts" setup>
import { useToast } from '~/components/ui/toast'

const { create, onLoginSuccess } = useUser()
const { toast } = useToast()

const onSubmitLogin = async (values: { email: string; password: string }) => {
  try {
    await create({ email_address: values.email ?? '', password: values.password ?? '' })
    onLoginSuccess()
  } catch (error) {
    toast({
      title: 'Login Failed',
      description: 'Invalid email or password. Please try again.',
      variant: 'destructive',
    })
  }
}
</script>
